import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import HPinputModal from "@components/common/HPInputModal";
import { t } from "@utils/i18n";

interface DatasetRenameModalProps {
  action: () => void;
  initialValue?: string;
}

const DatasetRenameModal: React.FC<DatasetRenameModalProps> = ({
  action,
  initialValue,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <HPinputModal
      title={t("pages.datasetDetails.renameDataset")}
      cancelButtonText={t("common.cancel")}
      confirmButtonText={t("common.rename")}
      confirmButtonIcon={<i className="fas fa-check"></i>}
      loading={false}
      onConfirm={action}
      onCancel={closeTopModal}
      initialValue={initialValue}
    />
  );
};

export default DatasetRenameModal;
